class ProfileDocumentsController {
  /* @ngInject */
  constructor(DocumentsService, endPoints, docService, $rootScope, LoginService, scaTypeConstants) {
    const that = this;

    that.documentObj = {};
    that.loading = false;
    that.scaRequired = false;

    that.getDocumentList = () => {
      that.loading = true;
      DocumentsService.getDocumentList().then(
      (list) => {
        that.documentObj = list;
        that.loading = false;
      },
      () => {
        that.loading = false;
      }
    );
    };

    that.getMerchantConv = () => {
      DocumentsService.getMerchantConv().then((result) => {
        if (result) {
          that.documentConvMerchant = result[0];
        }
      });
    };

    that.showPdfConvMerch = (doc) => {
      const url = `${endPoints.webApiUrl}static-assets/documents/termini/${doc.idtermini}`;
      docService.showDoc(url, true);
    };

    that.showPdf = (doc) => {
      DocumentsService.showDoc(doc);
    };

    that.checkSca = () => {
      if(!LoginService.getUserRole().includes('ROLE_SCA_'+scaTypeConstants.DOCUMENTS)){
        that.scaRequired = true
      }else{
        that.scaRequired = false
      }
    }
    
    $rootScope.$on('POLLER_SCA_COMPLETED_TYPE_'+scaTypeConstants.DOCUMENTS, that.checkSca);

    that.checkSca()
    that.getDocumentList();
    that.getMerchantConv();

  }
}

export default ProfileDocumentsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/documents/documents.controller.js
 **/